import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
const FAQS: FAQItem[] = [{
  question: '¿Cómo recibo el ebook y los bonos?',
  answer: 'El acceso es inmediato. En menos de 2 minutos después de tu compra, recibirás un correo electrónico con el enlace de descarga. Podrás leerlo en tu celular, tablet o computadora. No tienes que esperar nada.'
}, {
  question: '¿Es un libro físico o digital?',
  answer: 'Es un libro digital (ebook) en formato PDF. Esto es una ventaja: lo tienes siempre contigo en tu celular, listo para abrir en el momento exacto que lo necesites. Sin esperar envíos, sin costos adicionales.'
}, {
  question: '¿Y si no me gusta? ¿Puedo pedir reembolso?',
  answer: 'Por supuesto. Tienes una garantía incondicional de 7 días. Si sientes que el libro no es para ti, te devolvemos el 100% de tu dinero sin hacer una sola pregunta. El riesgo es cero para ti.'
}, {
  question: '¿Es seguro pagar con mi tarjeta?',
  answer: 'Totalmente seguro. Tu compra se procesa a través de Hotmart, la plataforma de productos digitales más grande y confiable de Latinoamérica. Tus datos están protegidos con encriptación de nivel bancario.'
}, {
  question: '¿Necesito saber mucho de la Biblia para usar esta guía?',
  answer: 'Para nada. Este ebook está diseñado especialmente para personas que no saben por dónde empezar. Todo está explicado en lenguaje simple, claro y sin tecnicismos religiosos. Es como tener a alguien que te guía paso a paso.'
}, {
  question: '¿Los 4 bonos realmente están incluidos gratis?',
  answer: 'Sí, los 4 bonos (valorados en $45.96) están incluidos sin costo adicional con tu compra de hoy. Los recibes junto con el ebook principal en el mismo correo de descarga. Esta oferta es por tiempo limitado.'
}, {
  question: '¿Es de alguna religión o iglesia específica?',
  answer: 'No. Esta guía usa la Biblia como fuente de sabiduría, consuelo y paz. No pertenece a ninguna denominación ni iglesia específica. Es para cualquier mujer que cree en Dios y busca respuestas.'
}];
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="w-full max-w-3xl mx-auto space-y-4" data-id="element-20">
      {FAQS.map((faq, index) => <div key={index} className="bg-white rounded-lg border border-amber-100 overflow-hidden shadow-sm" data-id="element-21">
          <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-22">
            <span className="font-serif font-semibold text-lg text-gray-800 pr-4" data-id="element-23">
              {faq.question}
            </span>
            {openIndex === index ? <ChevronUp className="w-5 h-5 text-amber-600 flex-shrink-0" data-id="element-24" /> : <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-25" />}
          </button>

          <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-64 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-26">
            <p className="text-gray-600 leading-relaxed" data-id="element-27">{faq.answer}</p>
          </div>
        </div>)}
    </div>;
}